import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { twMerge } from "tailwind-merge";
import { useMenu } from "../stores/menu";
import useOnlineStatus from "../hooks/useOnlineStatus";
import OfflineWarning from "./OfflineWarning";
import NotificationToastContainer from "./NotificationToastContainer";
import NewReleaseAvailable from "./NewReleaseAvailable";
import useNewReleaseAvailable from "../hooks/useNewReleaseAvailable";

const Layout = () => {
  const { collapse } = useMenu();
  const { isOnline } = useOnlineStatus();
  const { hasNewReleaseNote } = useNewReleaseAvailable();

  return (
    <div className="flex flex-col h-screen">
      {!isOnline && <OfflineWarning />}
      {hasNewReleaseNote && <NewReleaseAvailable />}

      <div className={twMerge("flex", !isOnline && '-mt-9', hasNewReleaseNote && 'mt-9 max-h-[calc(100vh-36px)]')}>
        <Sidebar />

        <div className={twMerge("w-[calc(100vw-283px)] p-8", collapse && 'w-[calc(100vw-88px)]', !isOnline && 'mt-4 h-[calc(100vh-20px)]', hasNewReleaseNote && '-mt-2 h-[calc(100vh-36px)]')}>
          <Outlet />
        </div>
      </div>

      <NotificationToastContainer />
    </div>
  );
};

export default Layout;